'use strict';

/*
	Build Chart wrapper.
 */
/*Build Chart wrapper.*/
function buildWrapper() {
	var _this = this,
	    wrapper,
		header,
		chart,
		footer;

		_this.cnt = {
			wrapper: wrapper = div({
				'border': _this.config.menu ? (isDarkMode == false ? '1px solid #d9dadb' : '1px solid rgb(35,35,35)') : '0px',
				//'border': _this.config.menu ? '1px solid #d9dadb' : '0px',
			}, {
				"class": isDarkMode == true ? 'iChart iChart-wrapper darkTopWrapper' : 'iChart iChart-wrapper'
			}),
			header: header = div({}, {
				"class": 'iChart-wrapper-header'
			}),
			chart: chart = div({}, {
				tabindex: 0,
				"class": 'iChart-chart'
			}),
			footer: footer = div({}, {
				"class":  isDarkMode == true ? 'iChart-wrapper-footer darkBottomWrapper' : 'iChart-wrapper-footer'
			})
		};

	if (!_this.config.menu) {
		_this.cnt.header.css({ 'height': '0px' });
	}

	wrapper.append(header).append(chart).append(footer);
	_this.c.append(wrapper);

	this.cnt.wrapper.mouseenter(function () {
		window.currentChart = _this;
	});

	wrapper.on('click', function () {
		var fn;
		if (fn = _this.config.events.click) {
			fn.call(_this, _this.config.cdata);
		}
	});
};